<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { MEMBERS } from '@/store/types';
import membersApi from '../../apis/members.api';

export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
    per_page: {
      type: Number,
      default: 10,
    },
  },

  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = membersApi.useCustomEmailsQuery({
      page: props.page,
      per_page: props.per_page,
    });
    if (query.value) {
      store.commit(MEMBERS.SET_CUSTOMEMAILS_QUERY, query);
    }
    return { query };
  },
};
</script>
